import clsx from 'clsx';
import type { ReactElement, ReactNode } from 'react';

import type { StatsRowVariant } from '../../core/stats/Stats';
import { StatsRow } from '../../core/stats/Stats';

export type JobArchitectureStatistics = {
    readonly approvedLevels?: number;
    readonly approvedRoles?: number;
    readonly clustersCount?: number;
    readonly expected: number;
    readonly familiesCount?: number;
    readonly levelsCount?: number;
    readonly profiles: number;
    readonly publishedLevels?: number;
    readonly publishedRoles?: number;
    readonly reviewed: number;
    readonly reviewerLevels?: number;
    readonly reviewers: number;
    readonly reviewerRoles?: number;
    readonly rolesCount?: number;
};

export type JobArchitectureStatsVariant = 'item' | 'trigger';

export type JobArchitectureStatsProps<TStatistics = JobArchitectureStatistics> = {
    readonly className?: string;
    readonly getStatsContent: (data: TStatistics | undefined) => ReactNode;
    readonly statistics: TStatistics | undefined;
    readonly variant?: JobArchitectureStatsVariant;
};

const variantMap: Record<JobArchitectureStatsVariant, StatsRowVariant> = {
    item: 'item',
    trigger: 'trigger',
};

export const JobArchitectureStats = <TStatistics = JobArchitectureStatistics>({
    className,
    getStatsContent,
    statistics,
    variant = 'trigger',
}: JobArchitectureStatsProps<TStatistics>): ReactElement => (
    <StatsRow className={clsx('gap-1', className)} variant={variantMap[variant]}>
        {getStatsContent(statistics)}
    </StatsRow>
);
